import {getSignedDocuments} from "../functions/signedDocPage/GetSignedDocuments";
import {sendLog} from "../functions/common/SendLog";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {ServerApi} from "../api/ServerApi";

//Стили
import "./style/documents.css";
import "./style/palette.css";
import "./style/common.css";

//Страница №6
//Страница списка подписанных документов для просмотра и скачивания
export default function SignedDocPage() {
    const title = 'Страница 6. Страница списка подписанных документов для просмотра и скачивания.';

    const docSessionCode = localStorage.getItem("doc_session_code");
    const appLogicType = localStorage.getItem("app_logic_type");
    const phone = JSON.parse(localStorage.getItem("phone"));
    const site = JSON.parse(localStorage.getItem("site"));
    const appDebag = localStorage.getItem("app_debag");
    const userName = localStorage.getItem("username");
    const serverApi = new ServerApi();

    const [payInfo, setPayInfo] = useState({pay: false, paydata: {link: "", paylink: false}});
    const [signedDocs, setSignedDocs] = useState([]);

    //? State для скачивания — отдельные лоадеры для каждого типа файла
    const [loadingDocId, setLoadingDocId] = useState(null);      // для zip
    const [loadingPdfId, setLoadingPdfId] = useState(null);      // для pdf
    const [loadingSigId, setLoadingSigId] = useState(null);      // для sig
    const [retryTrigger, setRetryTrigger] = useState(0);
    const [downloadTask, setDownloadTask] = useState(null);      // { code, id, fileType }

    const navigate = useNavigate();

    // Кнопка "Позвонить оператору"
    const handleCall = () => {
        window.location.href = `tel:${phone?.data}`;
    };

    // Перейти на страницу "Совершить оплату"
    const handleMakePaymentClick = () => {
        navigate("/payments", {
            state: payInfo.paydata.link,
        });
    };

    //? Универсальный хендлер клика по скачиванию (принимает fileType)
    const handleDownloadClick = (code, id, fileType = 'zip') => {
        if (
            (fileType === 'zip' && loadingDocId === id) ||
            (fileType === 'pdf' && loadingPdfId === id) ||
            (fileType === 'sig' && loadingSigId === id)
        ) return;

        if (fileType === 'zip') setLoadingDocId(id);
        if (fileType === 'pdf') setLoadingPdfId(id);
        if (fileType === 'sig') setLoadingSigId(id);

        setDownloadTask({ code, id, fileType });
    };

    //? Запрос скачивания + обработка reload. Срабатывает ТОЛЬКО при клике
    useEffect(() => {
        if (!downloadTask) return;
        const { code, id, fileType = 'zip' } = downloadTask;

        serverApi.downloadFile(code, id, fileType, appDebag).then(async (response) => {
            const blob = response.data;
            const contentType = response.headers['content-type'] || '';

            // 1. Если сервер вернул JSON (например, с reload или ошибкой)
            if (contentType.includes('application/json')) {
                const text = await blob.text();
                try {
                    const json = JSON.parse(text);
                    if (json?.reload !== undefined) {
                        setRetryTrigger(Number(json.reload) + 1);
                        return;
                    }
                } catch (e) {
                    console.log(e);
                }
            }

            // 2. Если это реальный файл
            if (blob.size > 0) {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const ext = fileType === 'zip' ? 'zip' : fileType;
                link.download = `document_${id}.${ext}`;

                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } else {
                console.log('Пустой Blob от сервера');
            }

            // Снимаем лоадеры и очищаем задачу (успех или пустой ответ)
            if (fileType === 'zip') setLoadingDocId(null);
            if (fileType === 'pdf') setLoadingPdfId(null);
            if (fileType === 'sig') setLoadingSigId(null);
            setDownloadTask(null);

        }).catch((error) => {
            console.log(`Ошибка downloadFile (${fileType}):`, error);
            sendLog(serverApi, title, `Ошибка downloadFile (${fileType})`, 'downloadFile', true, error);

            if (fileType === 'zip') setLoadingDocId(null);
            if (fileType === 'pdf') setLoadingPdfId(null);
            if (fileType === 'sig') setLoadingSigId(null);
            setDownloadTask(null);
        });
    }, [downloadTask, retryTrigger, docSessionCode]);

    // Загрузка списка документов при маунте страницы
    useEffect(() => {
        if (Number(appLogicType) !== 2) {
            getSignedDocuments(docSessionCode, title, appDebag).then((response) => {
                setSignedDocs(response);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, []);

    return (
        <div id={"doc-page"}>
            <div className={"fixed-top mx-auto"}>
                <div className={"header d-flex align-items-center justify-content-between background_white"} style={{opacity: 1}}>
                    <h1 className={"header-title color_night_blue weight600_project size20_project"}>
                        {userName}
                    </h1>
                    <img src={"./icons/gos.png"} className={"logo-gos"} alt="Госуслуги"/>
                </div>
            </div>

            <div className={"doc-block w-100"}>
                {Number(appLogicType) === 2 ? (  //** Кейс = 2 *//
                        <div className={"margin100_top margin20_bottom greeting-text-block"}>
                            <h1 className={"greeting-title text-center"}>
                                Ваши данные актуализированы
                            </h1>
                        </div>
                ) : (  //** Кейс = 1 **//
                    <div className={"all-doc margin100_top margin20_bottom"}>
                        {signedDocs && signedDocs.map((item) => {
                            const isLoadingZip = loadingDocId === item.id;
                            const isLoadingPdf = loadingPdfId === item.id;
                            const isLoadingSig = loadingSigId === item.id;

                            return (
                                <div key={item.upload_id}>
                                    <div className={"signed-item mx-2 d-flex justify-content-between align-items-center background_white"}>
                                        <div>
                                            <div className={"signed-name"}>
                                                {item.name}
                                            </div>

                                            <div className={"cursor d-flex mt-2"}>
                                                {/* Скачать PDF */}
                                                <div className={"signed-date text-start size14_project weight400_project color_steel_grey"}>
                                                    <a href="#"
                                                       onClick={(e) => {
                                                           e.preventDefault();
                                                           handleDownloadClick(docSessionCode, item.id, 'pdf');
                                                       }}
                                                       style={{
                                                           pointerEvents: isLoadingPdf ? 'none' : 'auto',
                                                           opacity: isLoadingPdf ? 0.6 : 1,
                                                           textDecoration: 'none',
                                                           color: 'inherit'
                                                       }}
                                                    >
                                                        Скачать PDF
                                                        <i className={"fa fa-download"} aria-hidden={"true"}></i>
                                                    </a>
                                                </div>

                                                {/* Скачать SIG */}
                                                <div className={"signed-date text-start size14_project weight400_project color_steel_grey"}>
                                                    <a href="#"
                                                       onClick={(e) => {
                                                           e.preventDefault();
                                                           handleDownloadClick(docSessionCode, item.id, 'sig');
                                                       }}
                                                       style={{
                                                           pointerEvents: isLoadingSig ? 'none' : 'auto',
                                                           opacity: isLoadingSig ? 0.6 : 1,
                                                           textDecoration: 'none',
                                                           color: 'inherit'
                                                       }}
                                                    >
                                                        Скачать SIG
                                                        <i className={"fa fa-download"} aria-hidden={"true"}></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Блок скачивания архива (ZIP) */}
                                        <div className={'signed-doc-img-block'}>
                                            {isLoadingZip ? (
                                                <div className={'download_loader rounded-circle'} />
                                            ) : (
                                                <a
                                                    href={item.zipPath}
                                                    download
                                                    title={"Скачать архив"}
                                                    onClick={(e) => {
                                                        if (!item.zipPath) {
                                                            e.preventDefault();
                                                            handleDownloadClick(docSessionCode, item.id, 'zip');
                                                        }
                                                    }}
                                                >
                                                    <img className={'width24px height24px ms-2'} src={"./icons/load.svg"} alt={"Скачать архив"} />
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                <div>
                    {(payInfo?.pay === 'true' || payInfo?.pay === true) &&
                        (payInfo?.paydata?.paylink ?
                                <a href={payInfo.paydata.link} target={"_blank"} rel="noopener noreferrer">
                                    <div className={"signed-item1 mx-2 d-flex justify-content-between align-items-center"}>
                                        <div className={'d-flex align-items-center'}>
                                            <img className={'signed-doc-img'} src={"./icons/Ruble.svg"} alt="Ruble"/>
                                            <div className={"signed-name"}>
                                                Совершить оплату
                                            </div>
                                        </div>
                                        <div className={'width24px height24px'}>
                                            <img className={'signed-doc-img'} src={"./icons/Arrow.svg"} alt="Arrow"/>
                                        </div>
                                    </div>
                                </a> :
                                <div className={"signed-item1 mx-2 d-flex justify-content-between align-items-center"}
                                     onClick={handleMakePaymentClick} style={{cursor: 'pointer'}}>
                                    <div className={'d-flex align-items-center'}>
                                        <img className={'signed-doc-img'} src={"./icons/Ruble.svg"} alt="Ruble"/>
                                        <div className={"signed-name"}>
                                            Совершить оплату
                                        </div>
                                    </div>
                                    <div className={'width24px height24px'}>
                                        <img className={'signed-doc-img'} src={"./icons/Arrow.svg"} alt="Arrow"/>
                                    </div>
                                </div>
                        )
                    }

                    {site?.success ?
                        <a href={site?.data} target={"_blank"} rel="noopener noreferrer">
                            <div className={"signed-item1 mx-2 d-flex justify-content-between align-items-center"}>
                                <div className={'d-flex align-items-center'}>
                                    <img className={'signed-doc-img'} src={"./icons/Global.svg"} alt="Global"/>
                                    <div className={"signed-name"}>
                                        На сайт оператора
                                    </div>
                                </div>
                                <div className={'width24px height24px'}>
                                    <img className={'signed-doc-img'} src={"./icons/Arrow.svg"} alt="Arrow"/>
                                </div>
                            </div>
                        </a> : ''
                    }
                    {phone?.success ?
                        <div className={"signed-item1 mx-2 d-flex justify-content-between align-items-center"}
                             onClick={handleCall} style={{cursor: 'pointer'}}>
                            <div className={'d-flex align-items-center'}>
                                <img className={'signed-doc-img'} src={"./icons/Call.svg"} alt="Call"/>
                                <div className={"signed-name"}>
                                    Позвонить оператору
                                </div>
                            </div>
                            <div className={'width24px height24px'}>
                                <img className={'signed-doc-img'} src={"./icons/Arrow.svg"} alt="Arrow"/>
                            </div>
                        </div> : ''
                    }
                </div>

            </div>
        </div>
    );
}
